import { Genders } from "../constants/Genders";

export class KeyMoment {
    game: string;
    redCardIdx: number;
    winningBlackCardIdx: number;
    criminalName: string;
    criminalGender: Genders;
    criminalImage: string;
    winnerName: string;

    constructor(game: string, redCardIdx: number, winningBlackCardIdx: number, criminalName: string, criminalGender: Genders, criminalImage: string, winnerName: string) {
        this.game = game;
        this.redCardIdx = redCardIdx;
        this.winningBlackCardIdx = winningBlackCardIdx;
        this.criminalName = criminalName;
        this.criminalGender = criminalGender;
        this.criminalImage = criminalImage;
        this.winnerName = winnerName;
    }
}